import { YoutubeLinkRepository, YoutubeLinkFilters } from '../../domain/repositories/youtube-link.repository.js';
import { YoutubeLinkEntity } from '../../domain/entities/youtube-link.entity.js';

export class GetYoutubeLinksUseCase {
  constructor(private readonly repository: YoutubeLinkRepository) {}

  public async execute(filters?: YoutubeLinkFilters): Promise<YoutubeLinkEntity[]> {
    return this.repository.getAll(filters);
  }
}
